// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-card {
  pointer-events: 'none';
  cursor: 'auto';
  margin-right: 30px;
  margin-bottom: 30px;
  min-height: 450px;
}
.title {
  font-family: "Open Sans";
  font-size: 32px;
  font-weight: 600;
  text-align: left;
  color: #006BA0;
}
.subtitle {
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  color: #4C5060;
}
.card-container {
  padding: 40px 0 0 40px;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: row;
}
.card-container .ant-card {
  width: 60%;
  height: 60%;
}
@media screen and (min-width: 900px) {
  .card-container .ant-card {
    width: 40%;
    height: 50%;
  }
}
@media screen and (min-width: 1140px) {
  .card-container .ant-card {
    width: 25%;
    height: 50%;
    min-height: 394px;
  }
}
.card-container-modeling {
  padding: 40px 0 0 40px;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: row;
}
.card-container-modeling .ant-card {
  width: 40%;
  height: 40%;
}
@media screen and (min-width: 900px) {
  .card-container-modeling .ant-card {
    width: 40%;
    height: 50%;
  }
}
@media screen and (min-width: 1140px) {
  .card-container-modeling .ant-card {
    width: 20%;
    height: 50%;
    min-height: 400px;
  }
}
.disabled {
  filter: grayscale(100%);
  cursor: default;
  opacity: 0.7;
}
.crumbs {
  color: #fff;
  font-size: 16px;
}
.crumbs a {
  color: #66D1FF;
  text-decoration: none;
}
.crumbs a:hover {
  color: #CAEEFF;
}
.platform-title {
  font-size: 32px;
  color: #fff;
}
.platform-subtitle {
  font-size: 16px;
  color: #fff;
}
.title-wrapper {
  background-color: #00000011;
  width: 100%;
  padding-top: 20px;
  padding-left: 40px;
  border-bottom: solid 1px #222;
}
.app-card.with-spinner {
  position: relative;
}
.spinner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 2;
}
.jupyter-existing-server {
  display: flex;
  width: 100vw !important;
  height: 980px;
  justify-content: center;
  align-items: center;
  background: rgba(51, 51, 51, 0.6);
  border-radius: 4px;
  box-shadow: 0px 16px 24px 0px rgba(0, 0, 0, 0.07), 0px 6px 30px 0px rgba(0, 0, 0, 0.06), 0px 8px 10px 0px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  top: 0;
  position: absolute;
}
@media screen and (max-width: 768px) {
  .jupyter-existing-server {
    height: 80vh;
  }
}
.jupyter-existing-server .jupyter-existing-server-content {
  background-color: #414855;
  color: white;
  width: 600px;
  height: auto;
  padding: 40px 40px 32px 40px;
  overflow-y: auto;
  border-radius: 4px;
  box-shadow: 0px 16px 24px 0px rgba(0, 0, 0, 0.07), 0px 6px 30px 0px rgba(0, 0, 0, 0.06), 0px 8px 10px 0px rgba(0, 0, 0, 0.1);
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/CardPageStyles.less"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AACJ;AAEA;EACI,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAAJ;AAGA;EACI,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AADJ;AAIA;EACI,sBAAA;EACA,aAAA;EAEA,WAAA;EACA,eAAA;EACA,mBAAA;AAHJ;AAHA;EASQ,UAAA;EACA,WAAA;AAHR;AAKQ;EAAA;IACI,UAAA;IACA,WAAA;EAFV;AACF;AAIQ;EAAA;IACI,UAAA;IACA,WAAA;IACA,iBAAA;EADV;AACF;AAKA;EACI,sBAAA;EACA,aAAA;EAEA,WAAA;EACA,eAAA;EACA,mBAAA;AAJJ;AAFA;EASQ,UAAA;EACA,WAAA;AAJR;AAMQ;EAAA;IACI,UAAA;IACA,WAAA;EAHV;AACF;AAKQ;EAAA;IACI,UAAA;IACA,WAAA;IACA,iBAAA;EAFV;AACF;AAMA;EACI,uBAAA;EACA,eAAA;EACA,YAAA;AAJJ;AAOA;EACI,WAAA;EACA,eAAA;AALJ;AAOA;EACI,cAAA;EACA,qBAAA;AALJ;AAOA;EACI,cAAA;AALJ;AAQA;EACI,eAAA;EACA,WAAA;AANJ;AAQA;EACI,eAAA;EACA,WAAA;AANJ;AASA;EACI,2BAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;AAPJ;AAUA;EACI,kBAAA;AARJ;AAWA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0CAAA;EACA,UAAA;AATJ;AAYA;EACI,aAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,4HAAA;EACA,aAAA;EACA,MAAA;EACA,kBAAA;AAVJ;AAYI;EAAA;IACI,YAAA;EATN;AACF;AANA;EAkBQ,yBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,4HAAA;EACA,cAAA;AATR","sourcesContent":[".app-card {\n    pointer-events: 'none';\n    cursor: 'auto';\n    margin-right: 30px;\n    margin-bottom: 30px;\n    min-height: 450px\n}\n\n.title {\n    font-family: \"Open Sans\";\n    font-size: 32px;\n    font-weight: 600;\n    text-align: left;\n    color: #006BA0;\n}\n\n.subtitle {\n    font-family: \"Open Sans\";\n    font-size: 16px;\n    font-weight: 400;\n    text-align: left;\n    color: #4C5060;\n}\n\n.card-container {\n    padding: 40px 0 0 40px;\n    display: flex;\n    // height: 80vh;\n    width: 100%;\n    flex-wrap: wrap;\n    flex-direction: row;\n\n    .ant-card  {\n        width: 60%;\n        height: 60%;\n\n        @media screen and (min-width: 900px) {\n            width: 40%;\n            height: 50%;\n        }\n\n        @media screen and (min-width: 1140px) {\n            width: 25%;\n            height: 50%;\n            min-height: 394px;\n        }\n    }\n}\n\n.card-container-modeling {\n    padding: 40px 0 0 40px;\n    display: flex;\n    // height: 80vh;\n    width: 100%;\n    flex-wrap: wrap;\n    flex-direction: row;\n\n    .ant-card  {\n        width: 40%;\n        height: 40%;\n\n        @media screen and (min-width: 900px) {\n            width: 40%;\n            height: 50%;\n        }\n\n        @media screen and (min-width: 1140px) {\n            width: 20%;\n            height: 50%;\n            min-height: 400px;\n        }\n    }\n}\n\n.disabled {\n    filter: grayscale(100%);\n    cursor: default;\n    opacity: 0.7; \n}\n\n.crumbs {\n    color: #fff;\n    font-size: 16px;\n}\n.crumbs a {\n    color: #66D1FF;\n    text-decoration: none;\n}\n.crumbs a:hover {\n    color: #CAEEFF\n}\n\n.platform-title {\n    font-size: 32px;\n    color: #fff;\n}\n.platform-subtitle {\n    font-size: 16px;\n    color: #fff;\n}\n\n.title-wrapper {\n    background-color: #00000011;\n    width: 100%;\n    padding-top: 20px;\n    padding-left: 40px;\n    border-bottom: solid 1px #222;\n}\n\n.app-card.with-spinner {\n    position: relative;\n}\n\n.spinner-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: rgba(255, 255, 255, 0.7);\n    z-index: 2;\n}\n\n.jupyter-existing-server {\n    display: flex;\n    width: 100vw !important;\n    height: 980px;\n    justify-content: center;\n    align-items: center;\n    background: rgba(51, 51, 51, 0.60);\n    border-radius: 4px;\n    box-shadow: 0px 16px 24px 0px rgba(0, 0, 0, 0.07), 0px 6px 30px 0px rgba(0, 0, 0, 0.06), 0px 8px 10px 0px rgba(0, 0, 0, 0.10);\n    z-index: 1000;\n    top: 0;\n    position: absolute;\n\n    @media screen and (max-width: 768px) {\n        height: 80vh; \n    }\n\n    .jupyter-existing-server-content {\n        background-color: #414855;\n        color: white;\n        width: 600px;\n        height: auto;\n        padding: 40px 40px 32px 40px;\n        overflow-y: auto;\n        border-radius: 4px;\n        box-shadow: 0px 16px 24px 0px rgba(0, 0, 0, 0.07), 0px 6px 30px 0px rgba(0, 0, 0, 0.06), 0px 8px 10px 0px rgba(0, 0, 0, 0.10);\n        display: block;\n    }\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
